import { createFileRoute } from "@tanstack/react-router";
import { PortalEmbedPage } from "@/features/portalembeds/PortalEmbedPage";

/** An embedded app tab of the client's portal (B210): one https page the agency chose, inside the portal frame. */
export const Route = createFileRoute("/portal/apps/$tab")({
  component: PortalEmbedRoute,
});

function PortalEmbedRoute() {
  const { tab } = Route.useParams();
  return <PortalEmbedPage tabId={tab} />;
}
